<template>
  <section class="border border-cinza-3 rounded bg-white p-3 mb-3">
    <div class="form-row align-items-end">
      <div class="form-group col-md-4 mb-0">
        <label class="font-weight-700 font-size-12 text-cinza-7" for="filtro-nome">
          {{ $i18n('.filtros.nome') }}
        </label>
        <input
          id="filtro-nome"
          v-model="filtros.nome"
          type="text"
          class="form-control"
          :placeholder="$i18n('.filtros.placeholder_nome')"
          @input="aplicarFiltrosComDebounce"
        />
      </div>

      <div class="form-group col-md-4 mb-0">
        <label class="font-weight-700 font-size-12 text-cinza-7" for="filtro-rota">
          {{ $i18n('.filtros.rota') }}
        </label>
        <input
          id="filtro-rota"
          v-model="filtros.rotaPattern"
          type="text"
          class="form-control"
          :placeholder="$i18n('.filtros.placeholder_rota')"
          @input="aplicarFiltrosComDebounce"
        />
      </div>

      <div class="form-group col-md-2 mb-0">
        <label class="font-weight-700 font-size-12 text-cinza-7" for="filtro-status">
          {{ $i18n('.filtros.status') }}
        </label>
        <select
          id="filtro-status"
          v-model="filtros.ativo"
          class="form-control"
          @change="aplicarFiltros"
        >
          <option value="">{{ $i18n('.filtros.status_todos') }}</option>
          <option value="true">{{ $i18n('.filtros.status_ativos') }}</option>
          <option value="false">{{ $i18n('.filtros.status_inativos') }}</option>
        </select>
      </div>

      <div class="form-group col-md-2 mb-0">
        <button
          type="button"
          class="btn btn-nd-secondary w-100"
          :disabled="!temFiltroAtivo"
          @click="limparFiltros"
        >
          {{ $i18n('.filtros.limpar') }}
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ToursGuiadosAdminFiltro',
  emits: ['filtrar'],
  data() {
    return {
      filtros: {
        nome: '',
        rotaPattern: '',
        ativo: '',
      },
      debounceFiltros: null,
    }
  },
  beforeUnmount() {
    clearTimeout(this.debounceFiltros)
  },
  computed: {
    temFiltroAtivo() {
      return this.filtros.nome.trim() !== ''
        || this.filtros.rotaPattern.trim() !== ''
        || this.filtros.ativo !== ''
    },
  },
  methods: {
    emitirFiltros() {
      this.$emit('filtrar', { ...this.filtros })
    },
    aplicarFiltros() {
      this.emitirFiltros()
    },
    aplicarFiltrosComDebounce() {
      clearTimeout(this.debounceFiltros)
      this.debounceFiltros = setTimeout(() => this.emitirFiltros(), 300)
    },
    limparFiltros() {
      this.filtros.nome = ''
      this.filtros.rotaPattern = ''
      this.filtros.ativo = ''
      this.emitirFiltros()
    },
  },
}
</script>
